var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43511",
    "data-name": "Group 43511",
    transform: "translate(6879 -11617)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16120",
    "data-name": "Rectangle 16120",
    width: 28,
    height: 28,
    transform: "translate(-6879 11617)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "microphone_1_",
    "data-name": "microphone (1)",
    transform: "translate(-6875.365 11618.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37244",
    "data-name": "Path 37244",
    d: "M23.234,19.988a.929.929,0,0,1-.387-.084.942.942,0,0,1-.471-1.247,6.548,6.548,0,0,0,.583-2.715.942.942,0,1,1,1.885,0,8.418,8.418,0,0,1-.754,3.487.942.942,0,0,1-.856.559Z",
    transform: "translate(-5.998 -3.692)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37245",
    "data-name": "Path 37245",
    d: "M11,7.712a4.712,4.712,0,0,1,9.423,0V15.25a.942.942,0,0,1-.942.942Z",
    transform: "translate(-5.346 -3)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37246",
    "data-name": "Path 37246",
    d: "M25.455,24.122,6.609,5.276A.942.942,0,1,0,5.276,6.609l5.378,5.378v3.379a4.712,4.712,0,0,0,7.309,3.93l1.348,1.347A6.588,6.588,0,0,1,8.769,15.365a.942.942,0,1,0-1.885,0,8.49,8.49,0,0,0,7.538,8.425v1.94H11.6a.942.942,0,1,0,0,1.885h7.538a.942.942,0,1,0,0-1.885H16.308v-1.94a8.4,8.4,0,0,0,4.349-1.8l3.466,3.466a.942.942,0,1,0,1.333-1.333Z",
    transform: "translate(-5 -3.115)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneIcon);
export default __webpack_public_path__ + "static/media/microphone-icon.9a68e6ac65976d4934363bc8b8b0db7e.svg";
export { ForwardRef as ReactComponent };